import React from "react"
import TagManager from "react-gtm-module"

export default ({ gtm_id, data_layer }) => {
  TagManager.initialize({ gtmId: gtm_id, dataLayer: data_layer })
  return <div />
}
